import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from "@azure/msal-angular";
import {
  InteractionStatus,
  RedirectRequest,
  EventMessage,
  EventType,
} from "@azure/msal-browser";
import { filter, finalize, Subject, takeUntil } from "rxjs";
import { UserSerivice } from "./services/user.service";
import { Router } from "@angular/router";
import { WantedcreditService } from "./services/wantedcredit.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Biodiversity offset program";
  loginDisplay = false;
  isActive = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private userService: UserSerivice,
    private router: Router,
    private wantedCreditService: WantedcreditService
  ) {}

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe();
    this.authService.instance.enableAccountStorageEvents(); // Optional - This will enable ACCOUNT_ADDED and ACCOUNT_REMOVED events emitted when a user logs in or out of another tab or window
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.ACCOUNT_ADDED ||
            msg.eventType === EventType.ACCOUNT_REMOVED
        )
      )
      .subscribe((result: EventMessage) => {
        if (this.authService.instance.getAllAccounts().length === 0) {
          window.location.pathname = "/";
        }
      });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$),
        finalize(() => {
          this.userService.clearProfile();
          this.wantedCreditService.clearRequestId();
        })
      )
      .subscribe(() => {
        this.checkAndSetActiveAccount();
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  checkAndSetActiveAccount() {
    const activeAccount = this.authService.instance.getActiveAccount();
    if (!this.authService.instance.getAllAccounts().length) {
      return;
    }
    const [account, _] = activeAccount
      ? [activeAccount]
      : this.authService.instance.getAllAccounts();
    this.authService.instance.setActiveAccount(account);

    this.userService.getProfile().subscribe((v) => {
      if (!v || !v.active) {
        this.router.navigateByUrl("/account-status");
      }
    });
  }
}
